import get from 'lodash/get';
import { selectCurrentWorkspace } from 'store/Faraday/selectors';
import { selectCurrentHost } from 'store/Host/selectors';
import { selectedForWorking } from 'store/Contextualization/AssetDetail/selectors';
import { selectPathname } from 'store/Router/selectors';
import { selectWsDetailName } from 'store/Workspace/selectors';
import { selectAllowedByFeature, selectAllowedByRole } from 'Hooks/usePermission/selector';
import * as p from 'Hooks/usePermission/permissions';

export const selectTabsWithWorkspace = (state) => {
  const ws = selectCurrentWorkspace(state);
  const isEnabledByRole = (feature) => selectAllowedByRole(state, feature, p.PERMISSION_TYPES.READ);
  const isEnabledByFeature = (feature) => selectAllowedByFeature(state, feature, p.PERMISSION_TYPES.READ);

  return [
    {
      name: 'Dashboard',
      url: `/feed/${ws}`,
      enabledByRole: true,
      enabledByFeature: true
    },
    {
      name: 'Assets',
      url: `/host/${ws}`,
      enabledByRole: true,
      enabledByFeature: true
    },
    {
      name: 'Services',
      url: `/service/${ws}`,
      enabledByRole: true,
      enabledByFeature: true
    },
    {
      name: 'Vulnerabilities',
      url: `/manage/${ws}`,
      enabledByRole: true,
      enabledByFeature: true
    },
    {
      name: 'Credentials',
      url: `/credentials/${ws}`,
      enabledByRole: isEnabledByRole(p.FEATURE_CREDENTIALS),
      enabledByFeature: isEnabledByFeature(p.FEATURE_CREDENTIALS)
    }
  ];
};

export const selectTabs = () => {
  return [
    {
      name: 'Workspaces',
      url: '/workspaces',
      enabledByRole: true,
      enabledByFeature: true
    },
    {
      name: 'Assets',
      url: '/hosts',
      enabledByRole: true,
      enabledByFeature: true
    },
    {
      name: 'Services',
      url: '/services',
      enabledByRole: true,
      enabledByFeature: true
    },
    {
      name: 'Vulnerabilities',
      url: '/vulnerabilities',
      enabledByRole: true,
      enabledByFeature: true
    }
  ];
};

export const selectAssetTabs = (state) => {
  const ws = selectCurrentWorkspace(state);
  const host = selectCurrentHost(state);
  const hostId = get(host, 'id', 0);
  return [
    {
      name: 'Services',
      url: `/host/${ws}/${hostId}/services`,
      enabledByRole: true,
      enabledByFeature: true
    },
    {
      name: 'Vulnerabilities',
      url: `/host/${ws}/${hostId}/vulns`,
      enabledByRole: true,
      enabledByFeature: true
    }
  ];
};

export const generalView = (state) => {
  const pathname = selectPathname(state);
  const workspaceDetailName = selectWsDetailName(state);
  const isInGeneralView = (pathname === '/workspaces') ||
    (pathname.startsWith('/workspaces')) ||
    (pathname === `/workspaces/${workspaceDetailName}`) ||
    (pathname.startsWith('/hosts')) ||
    (pathname.startsWith('/vulnerabilities')) ||
    (pathname.startsWith('/services'));

  return isInGeneralView;
};

export const showTabsWithWs = (state) => {
  const pathname = selectPathname(state);
  const currentWs = selectCurrentWorkspace(state);
  const host = selectCurrentHost(state);
  const isInsideWs = pathname.startsWith('/feed/') ||
  (pathname === `/host/${currentWs}/${host.id}`) ||
  (pathname === `/host/${currentWs}`) ||
  pathname.startsWith('/manage/') ||
  pathname.startsWith('/vulns/') ||
  pathname.startsWith('/credentials/') ||
  pathname.startsWith('/service/');

  return isInsideWs;
};

export const insideAsset = (state) => {
  const pathname = selectPathname(state);
  const currentWs = selectCurrentWorkspace(state);
  const host = selectCurrentHost(state);
  const assetService = selectedForWorking('services', state);
  const assetVuln = selectedForWorking('vulns', state);

  const isInAsset = host && ((pathname === `/host/${currentWs}/${host.id}/vulns`) ||
    (pathname === `/host/${currentWs}/${host.id}/services`) ||
    (pathname === `/host/${currentWs}/${host.id}/services/${assetService.id}`) ||
    (pathname === `/host/${currentWs}/${host.id}/vulns/${assetVuln._id}`));

  return isInAsset;
};
